import request from '@webtrader/core/request';
import { ECommonResponseCode } from '@webtrader/core/request/message';

export enum EProfileType {
  NEW = 'NEW',
  EXISTING = 'EXISTING'
}
export interface IDemoAccountResponse {
  serverUrl: string;
  mobileUrl: string;
  login: number;
  password: string;
  qrCode: string;
  token: string;
}

export interface IRegisterDemoAccountResponse extends IDemoAccountResponse {
  profile: EProfileType;
}

export interface IRegisterDemoAccountParams {
  email: string;
}

interface IBaseAPIResponse<T> {
  code: ECommonResponseCode;
  result: T;
}

export default {
  registerDemoAccount: (params: IRegisterDemoAccountParams): Promise<IBaseAPIResponse<IRegisterDemoAccountResponse>> =>
    request.post(`/api/account/experience/v1/register`, params),
  resetPasswordDemoAccount: (params: IRegisterDemoAccountParams): Promise<IBaseAPIResponse<IDemoAccountResponse>> =>
    request.patch('/api/auth/v1/experience/password/reset', undefined, { params })
};
